import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { isEqual } from "lodash";
import { Component } from "preact";
import { h } from "preact";
import {
  ClientGroup_Columns,
  ClientGroup_Default_Columns,
  ClientList_Columns,
  ClientList_Default_Columns,
  DealList_Columns,
  DealList_DefaultColumns,
  Portfolio_ClientList_Default_Columns,
} from "../../common/components/DealListExport/nbiExportColumns";
import {
  DefaultSalesCreditExportcolumns,
  SalesCreditExportcolumns,
  sc_clientList_columns,
  sc_clientList_default_columns,
} from "../../common/components/DealListExport/SalescreditExportColumns";
import { SelectPicker } from "../../common/components/SelectPicker/SelectPicker";
import { IExportColumn } from "../../common/salescredit/salescredit-types";

// tslint:disable-next-line:interface-name
interface Props {
  onChange: (value: string[]) => void;
  board: string;
  exportColumns: string[];
}

// tslint:disable-next-line:interface-name
interface State {
  data: string[];
  exportColumns: string[];
}
const ClientSnapshotDealList = "cpr-nbi-export-deal-list";
const PortfolioDealList = "cpr-portfolio-export-deal-list";
const SalesCreditDealList = "cpr-salescredit-export-deal-list";
const PortfolioClientList = "cpr-portfolio-client-list";
const ClientSnapshotClientList = "cpr-nbi-client-list";
const ClientGroupClientList = "cpr-nbi-group-client-list";
const salesCreditClientList = "cpr-salescredit-client-list";

const ExportColumnsFactory: {
  [board: string]: () => IExportColumn[];
} = {
  "cpr-nbi-client-list": ClientList_Default_Columns,
  "cpr-nbi-export-deal-list": DealList_DefaultColumns,
  "cpr-nbi-group-client-list": ClientGroup_Default_Columns,
  "cpr-portfolio-client-list": Portfolio_ClientList_Default_Columns,
  "cpr-portfolio-export-deal-list": DealList_DefaultColumns,
  "cpr-salescredit-client-list": sc_clientList_default_columns,
  "cpr-salescredit-export-deal-list": DefaultSalesCreditExportcolumns,
};

export class ExportColumnsSelectorClass extends Component<
  Props & IWidgetConfigurationProps,
  State
> {
  public componentDidMount() {
    this.setState({ data: [] });
    switch (this.props.board) {
      case ClientSnapshotDealList: {
        this.setState({ data: DealList_Columns().map(x => x.headerName) });
        break;
      }
      case PortfolioDealList: {
        this.setState({ data: DealList_Columns().map(x => x.headerName) });
        break;
      }
      case SalesCreditDealList: {
        this.setState({
          data: SalesCreditExportcolumns().map(x => x.headerName),
        });
        break;
      }
      case PortfolioClientList: {
        this.setState({ data: ClientList_Columns().map(x => x.headerName) });
        break;
      }
      case ClientSnapshotClientList: {
        this.setState({ data: ClientList_Columns().map(x => x.headerName) });
        break;
      }
      case ClientGroupClientList: {
        this.setState({ data: ClientGroup_Columns().map(x => x.headerName) });
        break;
      }
      case salesCreditClientList: {
        this.setState({ data: sc_clientList_columns().map(x => x.headerName) });
        break;
      }
      default: {
        this.setState({ data: [] });
        break;
      }
    }
  }

  public render() {
    const exportColumns =
      this.props.exportColumns.length === 0
        ? ExportColumnsFactory[this.props.board]().map(x => x.headerName)
        : this.props.exportColumns;

    if (!isEqual(this.state.exportColumns, exportColumns)) {
      this.setState({ exportColumns });
    }
    const getItems = () => Promise.all(this.state.data);
    return (
      <SelectPicker
        getItems={getItems}
        onChange={this.valueChanged.bind(this)}
        tags={exportColumns}
      />
    );
  }
  private valueChanged(value: string[]) {
    this.setState({
      exportColumns:
        value && value.length > 0
          ? value
          : ExportColumnsFactory[this.props.board]().map(x => x.headerName),
    });
    this.props.onChange(this.state.exportColumns);
  }
}

export const ExportColumnsSelector = withWidgetConfiguration(
  ExportColumnsSelectorClass
);
